import type { MetalCode, StoneShapeCode } from '@/graphql/api'
import type {
    NonSkuGemstoneParams,
    NonSkuLabGrownParams,
    NonSkuParams,
} from '@/views/product/engagement-ring/composables/nonSkuParams.ts'
import { type RouteLocationNormalized } from 'vue-router'
import {
    gemstoneClarityPart,
    gemstoneColorGradePart,
    gemstoneColorPart,
    gemstoneCrystalPart,
    labGrownClarityPart,
    labGrownColorPart,
    metalSlugsPart,
    monolithShapePart,
    ROUTE_ENGAGEMENT_RING,
    ROUTE_ENGAGEMENT_RING_GEMSTONE,
    ROUTE_ENGAGEMENT_RING_LAB_GROWN,
} from '@/router'

export type EngagementRingProps = {
    slug: string
    metal: MetalCode
    suffixSlug: string
    shape: StoneShapeCode
    nonSku?: NonSkuParams
    isGrande: boolean
}

export function getEngagementRingProps(
    route: RouteLocationNormalized
): EngagementRingProps {
    const shape = monolithShapePart.extractor(route)

    const nonSku = getNonSkuParams(route, shape)
    const suffixSlug =
        typeof route.params['suffix'] === 'string'
            ? route.params['suffix'].substring(1)
            : ''

    const isGrande = route.params['grande'] === '-grande'

    return {
        ...route.params,
        slug: route.params['slug'] as string,
        metal: metalSlugsPart.extractor(route),
        shape,
        suffixSlug,
        nonSku,
        isGrande,
    }
}

export function isEngagementRingRoute(route: RouteLocationNormalized): boolean {
    if (ROUTE_ENGAGEMENT_RING_LAB_GROWN === route.name) {
        return true
    }

    if (ROUTE_ENGAGEMENT_RING_GEMSTONE === route.name) {
        return true
    }

    return ROUTE_ENGAGEMENT_RING === route.name
}

function getNonSkuParams(
    route: RouteLocationNormalized,
    shape: StoneShapeCode
): NonSkuGemstoneParams | NonSkuLabGrownParams | undefined {
    if (ROUTE_ENGAGEMENT_RING_LAB_GROWN === route.name) {
        return {
            type: 'lab-grown',
            params: {
                nonSkuLabGrownFilter: {
                    carat: route.params['caratWeight'],
                    clarity: labGrownClarityPart.extractor(route),
                    color: labGrownColorPart.extractor(route),
                    shape,
                },
            },
        } as NonSkuLabGrownParams
    }

    if (ROUTE_ENGAGEMENT_RING_GEMSTONE === route.name) {
        return {
            type: 'gemstone',
            params: {
                nonSkuGemStoneFilter: {
                    carat: route.params['caratWeight'],
                    clarity: gemstoneClarityPart.extractor(route),
                    color: gemstoneColorPart.extractor(route),
                    crystal: gemstoneCrystalPart.extractor(route),
                    shape,
                    grade: gemstoneColorGradePart.extractor(route),
                },
            },
        } as NonSkuGemstoneParams
    }

    return undefined
}
